import * as React from 'react'
import AddUserColor from '../../../../assets/icons_new/AddUserColor.svg'
import RefreshColor from '../../../../assets/icons_new/RefreshColor.svg'
import { useVehicles } from '@/modules/shared/context/vehicles/VehiclesContext'
import { VehicleFormProvider } from '../../context/VehicleFormContext'
import AddVehicleModal from '../../modals/vehicleAdd/AddVehicleModal'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useSideVehicleSelection } from '../../context/SideVehicleSelectionContext'
import Tooltip from '@/modules/drivers/shared/ToolTip'
import ActivateColor from '../../../../assets/icons_new/ActivateColor.svg'
import useVehicleService from '../../services/VehicleService'
import { useHasAccess } from '@/modules/shared/permissions'
interface VehicleBasicActionBarProps {
  companyId: string
}

const VehicleBasicActionBar: React.FC<VehicleBasicActionBarProps> = ({
  companyId,
}) => {
  const { refresh } = useVehicles()
  const { t } = useLocalize()
  const [isOpenAddVehicleModal, setIsOpenAddVehicleModal] =
    React.useState(false)

  const { sideCheckedIds, clearSide } = useSideVehicleSelection()

  const { activateVehicle } = useVehicleService()

  const { allowed: canEditVehicles } = useHasAccess({ permissions: 'canAddDriver' }, companyId)
  const hasSelection = sideCheckedIds.length > 0 && canEditVehicles

  // Jeden przycisk-przelacznik, jak w WPF: endpoint /vehicle/activate i tak odwraca
  // status kazdego zaznaczonego pojazdu (VehicleStorage.ActivateOrDeactivateVehicles),
  // wiec etykieta "Aktywuj" albo "Dezaktywuj" obiecywalaby kierunek, ktorego nie ma.
  const handleToggleActive = () => {
    if (!hasSelection) return
    const vehicleIds = sideCheckedIds.map(String)
    activateVehicle({ companyId, vehicleIds, setActive: true }).finally(() => {
      refresh()
      clearSide()
    })
  }
  return (
    <div className="tw-relative tw-z-[100] tw-w-full">
      <div className="tw-flex tw-w-full tw-justify-between tw-px-4 tw-py-1.5 md:tw-items-center">
        <div className="tw-flex tw-flex-col tw-gap-4 md:tw-flex-row md:tw-items-center">
          <p className="tw-text-sm">
            <span className="tw-font-medium">
              {sideCheckedIds?.length ?? 0}
            </span>{' '}
            {t('vehicleModule.vehicles-count')}
          </p>
          <div className="tw-hidden tw-h-5 tw-w-0.5 tw-bg-secondary lg:tw-block"></div>

          {canEditVehicles && (
            <>
              <div
                className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-p-2 hover:tw-bg-base-300 hover:tw-opacity-90"
                onClick={() => setIsOpenAddVehicleModal(true)}
              >
                <img src={AddUserColor} alt="Add Vehicle Icon" />
                <p className="tw-text-sm tw-font-medium tw-text-primary">
                  {t('vehicleBasics.new-vehicle')}
                </p>
              </div>
              <div className="tw-hidden tw-h-5 tw-w-0.5 tw-bg-secondary lg:tw-block"></div>
            </>
          )}
          <Tooltip
            disabled={!hasSelection}
            text={t('vehicleModule.toggle-active')}
            onClick={handleToggleActive}
          >
            <img src={ActivateColor} alt="Toggle vehicle activity" />
          </Tooltip>
        </div>

        <div
          className="tw-cursor-pointer hover:tw-opacity-90"
          onClick={() => refresh()}
        >
          <img src={RefreshColor} alt="Refresh Icon" />
        </div>
      </div>
      {isOpenAddVehicleModal && (
        <VehicleFormProvider companyId={companyId}>
          <AddVehicleModal
            companyId={companyId}
            isOpen={isOpenAddVehicleModal}
            close={() => setIsOpenAddVehicleModal(false)}
          />
        </VehicleFormProvider>
      )}
    </div>
  )
}

export default VehicleBasicActionBar
